<template>
  <div class="relative">
    <div>
      <label v-if="label" :for="id" class="text-sm text-gray block mb-2 inline-block">
        {{ label }}
      </label>
      <Popper v-if="tooltip != ''" :content="tooltip" arrow placement="top">
            <span class=" text-tertiary -ml-2 w-6 h-6 inline-block ml-0 flex items-center -top-[5px] justify-center">
              <Icon name="info" width="4" height="4"/>
            </span>
      </Popper>
    </div>
    <div :class="inputClass">

      <select
          :id="id"
          :readonly="readonly"
          :disabled="disabled"
          v-model="value"
          :tabindex="tabindex"
          @input="$emit('update:modelValue', $event.target.value)"
          @change="$emit('update:modelValue', $event.target.value)"
          @blur="$emit('blur');onBlur();"
          @focus="$emit('focus', $event),onFocus();"
          class="w-full h-full bg-transparent px-4 focus:outline-none appearance-none"
          style="padding-right: 48px"
      >
        <template v-for="option in options">
          <option :value="option.value" :selected="(option?.selected == true || option.value == modelValue) ? 'selected' : ''">
            {{ option.text }}
          </option>
        </template>
      </select>
      <div style="width: 48px" class="absolute h-full right-0 top-0 border-l w-0 flex items-center justify-center pointer-events-none" :class="this.hasErrors ? 'border-red' : 'border-white'">
        <Icon name="down" class="text-primary"/>
      </div>

    </div>
    <ValidationMessages class="align-baseline bottom text-sm text-red" v-if="validations" :validations="validations" :hide-errors="hideErrors" :has-errors="hasErrors"/>
  </div>
</template>

<script>

import Popper from "vue3-popper";

export default {
  components: {Popper},
  data() {
    return {
      focused: false,
      value: null
    }
  },
  props: {
    id: {
      type: String,
      default: null,
    },
    label: {
      type: String,
      default: "",
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    options: {
      type: Array,
      required: true,
      default: () => []
    },
    disabled: {
      type: Boolean,
      default: null,
    },
    tabindex: {
      type: Boolean,
      default: null,
    },
    modelValue: {
      type: [String, Number],
      default: "",
    },
    width: {
      type: String,
      default: null,
    },
    validations: {
      type: Array,
      default: () => []
    },
    hideErrors: {
      type: Boolean,
      required: false,
      default: false
    },
    tooltip: {
      type: String,
      default: '',
    },
    clickable: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  watch: {
    modelValue(newModelValue, oldModelValue) {
      this.value = newModelValue
    },
  },
  methods: {
    onFocus() {
      this.focused = true;
    },
    onBlur() {
      this.focused = false;
    },
  },
  computed: {
    hasErrors() {

      var hasErrors = false;
      this.validations.forEach(validation => {

        if (validation.condition) {
          hasErrors = true;
          return;
        }
      })

      return hasErrors;
    },
    inputClass() {
      return ['h-12 h-12 overflow-hidden relative border rounded-md text-md transition-colors ease-in-out duration-500 focus:outline-none', this.focused ? (!this.hasErrors ? 'border-primary text-gray' : 'border-red gray-input-error bg-white validation-error') : (!this.hasErrors ? 'bg-white text-gray border-gray-light' : 'border-red bg-white text-gray-input-error validation-error'), this.width ? 'w-' + this.width : 'w-full', !this.clickable ? 'pointer-events-none' : '',  this.disabled ? 'opacity-20' : ''];
    }
  },
  created(){
    this.value = this.modelValue;
  }
};
</script>
